import { action } from 'typesafe-actions';

import * as Types from 'types';

import { UsersActionTypes } from './types';
import { requestUser } from './api';

const receiveUsers = (users: Types.User[]) =>
  action(UsersActionTypes.RECEIVE_USERS, users);

const receiveUserCards = (users: Types.UserCard[]) =>
  action(UsersActionTypes.RECEIVE_USERS, users);

export const Actions = {
  receiveUsers,
  receiveUserCards,
};

export const fetchUserById =
  (id: number): Types.DefaultThunkAction =>
  (dispatch) => {
    requestUser(id).then((userCard) => {
      dispatch(receiveUserCards([userCard]));
    });
  };
